import React from 'react';
import { Modal, ModalBody, ModalFooter } from '@carbon/react';
import { useHideModal } from '@/lib/hooks/useModal';

const WrongResolutionWarning = ({ title='', content = '', hideModal }) => {
  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Ok"
      secondaryButtonText="Abbrechen"
      modalHeading={title}
      onRequestClose={hideModal}
      onRequestSubmit={hideModal}>
      <ModalBody>
        <p>
          {content}
        </p>
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
};

export default WrongResolutionWarning;
